export const successPageContainer =
  "flex items-center justify-center min-h-screen bg-gray-200 dark:bg-gray-900 px-4 py-6 w-full";

export const successCard =
  "bg-white dark:bg-gray-800 shadow-lg rounded-xl p-8 w-96 text-center";

export const successIcon = "flex justify-center mb-4";

export const iconStyle = "w-16 h-16 text-green-500";

export const successTitle =
  "text-2xl font-semibold text-gray-800 dark:text-white";

export const successText = "text-gray-600 dark:text-gray-300 mt-2";

export const continueButton =
  "mt-6 w-full px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition";

export const backButton =
  "mt-3 text-gray-500 hover:underline w-full";